<template>
  <div class="margin-y-3 margin-x-10">
    <h1 style="text-transform: uppercase; font-weight: 700; letter-spacing: 1px; font-size: 30px;" class="margin-t-4 margin-b-10">Campaign - {{ campaign_name }}</h1>
    <campaign-form ref="campaignForm" :campaign="campaign">
      <template v-slot:action-buttons>
        <ladda-button :click="() => { return updateCampaign(false) }" class="btn btn-primary btn-md">Save</ladda-button>
        <ladda-button :click="() => { return updateCampaign(true) }" class="btn btn-md">Save & view campaigns</ladda-button>
      </template>
    </campaign-form>

    <h2 class="flex justify-between align-center margin-t-10">Requests<router-link :to="{ name: 'requests.create', query: { campaign_id: campaign.id } }" style="font-size: 14px;"><i class="fa fa-plus"></i> &nbsp;Create Request</router-link></h2>
    <div style="list-style-type: none;">
      <div v-for="booking in bookings" :key="booking.id">
        <vetting-list-item v-if="booking.type === 'vetting'" :booking="booking"/>
        <request-list-item v-if="booking.type === 'request'" :booking="booking"/>
        <booking-list-item v-if="booking.type === 'booking'" :booking="booking"/>
      </div>
      <lazy-loading
        class="text-center"
        :loading="loading"
        :reached-bottom="getNextCampaignBookings"
        ref="lazyLoading">
        <pickstar-loading slot="loading"/>
        <span slot="finished"></span>
      </lazy-loading>
    </div>
  </div>
</template>
<script>
import CampaignForm from './CampaignForm'
import { http, notify } from 'utils'
import RequestListItem from '../booking/request/RequestListItem'
import VettingListItem from '../booking/vetting/VettingListItem'
import BookingListItem from '../booking/BookingListItem'
import LazyLoading from 'codium-lazy-loading'
export default {
  components: {BookingListItem, VettingListItem, RequestListItem, CampaignForm, LazyLoading},

  created () {
    this.getCampaign()
    this.getCampaignBookings()
  },

  methods: {
    getCampaign () {
      return http.get(`campaigns/${this.$route.params.id}`).then(response => {
        this.campaign = response.data
        this.campaign_name = this.campaign.name
      })
    },

    getCampaignBookings () {
      return http.get(`campaigns/${this.$route.params.id}/bookings`).then(response => {
        this.bookings = response.data.data
        this.pagination = response.data.meta
      })
    },

    getNextCampaignBookings () {
      if (this.pagination && this.pagination.current_page < this.pagination.last_page) {
        this.loading = true
        return http.get(`campaigns/${this.$route.params.id}/bookings`, { params: { page: this.pagination.current_page + 1 } }).then(response => {
          this.bookings.push(...response.data.data)
          this.pagination = response.data.meta
          this.loading = false
        })
      }
      return Promise.resolve()
    },

    updateCampaign (link) {
      if (this.$refs.campaignForm.$v.$invalid) {
        this.$refs.campaignForm.$v.$touch()
        return Promise.resolve()
      }
      return http.post(`campaigns/${this.$route.params.id}/update`, this.campaign).then(response => {
        notify.success('Successfully saved updates')
        if (link) {
          this.$router.push({ name: 'campaigns.index', params: { status: 'active' } })
        }
        this.campaign_name = response.data.name
      })
    }
  },

  data () {
    return {
      campaign: {},
      campaign_name: '',
      bookings: [],
      pagination: {},
      loading: false
    }
  }
}
</script>
